export const categoryColorMap: Record<string, { textColor: string; bgColor: string }> = {
    Cardiology: {
        textColor: '#B15427',
        bgColor: '#FEEED6',
    },
    Pulmonology: {
        textColor: '#3A620A',
        bgColor: '#ECFECB',
    },
    Nephrology: {
        textColor: '#2E7C73',
        bgColor: '#E6FAF9',
    },
    Endocrinology: {
        textColor: '#753AAB',
        bgColor: '#ECE6FA',
    },
    'General health': {
        textColor: '#1F5BA8',
        bgColor: '#E7F5FF',
    },
    Oncology: {
        textColor: '#8B1538',
        bgColor: '#FFE6ED',
    },
    Gastroenterology: {
        textColor: '#7C5C00',
        bgColor: '#FFF4D6',
    },
};

export const getCategoryConfig = (category: string) => {
    return (
        categoryColorMap[category] || {
            textColor: '#535862',
            bgColor: '#F5F5F5',
        }
    );
};

export const categories = Object.keys(categoryColorMap).map(cat => ({
    label: cat,
    value: cat,
    ...categoryColorMap[cat],
}));
